import React from 'react';
import {Table, TableHead, TableRow, TableCell, TableBody, styled} from '@mui/material';
import PropTypes from 'prop-types';

const UpSellRecommendationTable = (props: { data: any; handleClick : any;isUpSellRowHighlightingRequired: any;
  isUpSellRowHighlighted: any}) => {
const {data, handleClick, isUpSellRowHighlightingRequired, isUpSellRowHighlighted} = props;
const [rowHighlightIndex, setRowHighLightIndex] = React.useState(null);

    const StyledTableCellData = styled(TableCell)({
        backgroundColor: 'black',
        color: 'white',
        borderRight: '0.1px solid rgb(51, 50, 49)',
        borderBottom: '0.1px solid rgb(51, 50, 49)' ,
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: '0.63vw',
        fontFamily: 'BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif;',
        height: '57.34px',  
        padding:0, paddingLeft:'2px !important', paddingRight:'2px !important', paddingTop:'2px !important', paddingBottom:'2px !important'     
    });

    const handleClickLocal = (d1: any, index: any) => {
      if (rowHighlightIndex === d1.ItemNo) {
        index = null;
      }
      setRowHighLightIndex(index === null ? null : d1.ItemNo);
      handleClick(d1);  
      isUpSellRowHighlightingRequired(true);   
    }

    const setBackgroundColor = (itemNo: any) => {
      return isUpSellRowHighlighted === true && rowHighlightIndex !== null 
              && rowHighlightIndex !== itemNo ? 'black': '#1a1916';
    } 

    const numberFormatter = (num : any) => {
      if(num > 999 && num < 1000000){
          return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
      }else if(num > 1000000){
          return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
      }else if(num < 900){
          return num; // if value < 1000, nothing to do
      }
  }

    return (
      <Table stickyHeader style={{background: 'none', color: '#ffffff', border:'0.2px solid rgb(117, 189, 8)'}} >
        <TableHead>
            <TableRow >
              <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)', height: '27.34px' }} colSpan={7} className="alignCenter">
                Current Item
              </StyledTableCellData>
            </TableRow>
          <TableRow>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)'}}>Level 4</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Item No.</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Description</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Brand</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Quantity (CSs/year)<br /><br /></StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Revenue ($)</StyledTableCellData>
            <StyledTableCellData style={{borderBottom: '0.2px solid rgb(117, 189, 8)' }}>Margin ($)</StyledTableCellData>
          </TableRow>
        </TableHead>
        <TableBody>
            {data?.map((headCell: any, pIndex: number) => (
              <TableRow className={(isUpSellRowHighlighted === true && rowHighlightIndex !== null 
                && rowHighlightIndex !== headCell.ItemNo) ? "dim cursorPointer" : "cursorPointer"} style={{height: '57.34px' }} >
                <StyledTableCellData  style={{backgroundColor: setBackgroundColor(headCell.ItemNo),  borderRight: '0.1px solid rgb(51, 50, 49)',}} 
                   onClick={() => handleClickLocal(headCell, pIndex)} >{headCell.levelValue}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>{headCell.ItemNo}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>{headCell.Desc}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>{headCell.Brand}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>{headCell.Quantity}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>${numberFormatter(Math.round(headCell.Revenue))}</StyledTableCellData>

                <StyledTableCellData style={{backgroundColor: setBackgroundColor(headCell.ItemNo)}} 
                  onClick={() => handleClickLocal(headCell, pIndex)}>${numberFormatter(Math.round(headCell.Margin))}</StyledTableCellData>
              </TableRow>              
            ))}
        </TableBody>
      </Table>
    )
}

UpSellRecommendationTable.propTypes = {
	data: PropTypes.objectOf(PropTypes.object),
  handleClick: PropTypes.func,
  isUpSellRowHighlightingRequired: PropTypes.func,
  isUpSellRowHighlighted: PropTypes.bool,
};

export default UpSellRecommendationTable;
